/* eslint-disable no-restricted-imports */
/* eslint-disable functional/no-loop-statement */
import { SxProps } from '@mui/material';
import { combineSX } from '@/utils/combineSX';
import { DpContainer } from '../../DpContainer';
import { DpCatalogEntryCarouselHeaderContent } from '@/components/blocks/DpLibrary/DpCatalogEntryCarouselHeader/parts/DpCatalogEntryCarouselHeaderContent';
type Props = {
	title: string;
	href?: string;
	buttons?: { name: string; carouselId: string }[];
	titlesx?: SxProps;
	framesx?: SxProps;
};

export const DpCatalogEntryCarouselHeader: React.FC<Props> = ({
	title,
	href,
	buttons,
	framesx,
	titlesx,
}) => (
	<DpContainer withoutmargin sx={combineSX([...(Array.isArray(framesx) ? framesx : [framesx])])}>
		<DpCatalogEntryCarouselHeaderContent
			title={title}
			href={href}
			buttons={buttons}
			titlesx={titlesx}
		/>
	</DpContainer>
);
